module.exports = "/assets/data/79b9fb935b04c2d12c3f0a2dcf88d44d-SO32.data.json";